<template lang="pug">
  div(class="content")
    div(class="md-layout md-gutter md-alignment-center-center")
      div(class="md-layout-item md-size-50 md-medium-size-70 md-xsmall-size-100")
        md-card
          md-card-header(data-background-color="green")
            h4(class="title") Meeting Sign In
            p(class="category") Sign in to join us for today's meeting!
          md-card-content
            div(class="md-layout")
              div(class="text-center md-layout-item md-size-100")
                h3 {{user.first_name}} {{user.last_name}}
                h3 {{user.eid}}
              div(v-if="meeting" class="md-layout-item md-size-100 centered")
                div(class="centered md-layout-item md-size-50 padded")
                  md-icon(class="left-icon") calendar_today
                  p(class="large-text") {{short_date}}
              div(v-if="signedIn" class="text-center md-layout-item md-size-100")
                div(v-if="paidStatus")
                  md-icon(class="md-size-5x green") done_outline
                  h4 Signin Successful!
                div(v-else)
                  md-icon(class="md-size-5x red") highlight_off
                  h4 Sorry, we were not able to sign you in :( <br>Please make sure you have paid dues!
              div(v-else class="text-center md-layout-item md-size-100")
                h4(v-if="noMeeting") There's currently no active meeting!
                h4(v-else-if="initialError" class="error") There was an error loading the meeting, please try again.
                h4(v-else-if="signinError" class="error") There was an error signing in, please try again.
                md-button(v-else type="submit" v-on:click="signInMeeting") Sign In
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      user: null,
      signedIn: null,
      meeting: null,
      short_date: null,
      initialError: null,
      signinError: null,
      paidStatus: null,
      noMeeting: null,
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.getMeeting();
  },
  methods: {
    getMeeting() {
      axios.get('/api/org/get_current_meeting')
      .then((response) => {
        if(response.data.nomeeting){
          this.noMeeting = true;
        } else {
          this.meeting = response.data.meeting;
          let date_arr = this.meeting.date.split("-");
          this.short_date = date_arr[1] + "-" + date_arr[2];
          this.signedIn = response.data.signedIn;
          this.paidStatus = response.data.signedIn;
        }
      }).catch(() => {
        this.initialError = true;
      });
    },
    signInMeeting() {
      axios.post(`/api/org/meeting_signin/${this.meeting.id}`, {meeting: this.meeting.id})
      .then((response) => {
        this.signedIn = true;
        this.paidStatus = response.data.status;
      }).catch((response) => {
        this.signinError = true;
      });
    }
  }
}
</script>

<style scoped>
  form{
    margin-top: 100px;
  }

  .error {
    color: rgb(226, 0, 0);
  }

  .centered {
    text-align: center;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .left-icon {
    float: left;
    font-size: 35px !important;
    padding: 0 3vh 1vh 0;
    margin: 0;
  }

  .padded {
    padding: 4vh 0;
  }

  .large-text {
    font-size: 220%;
  }

  .green {
    color: green !important;
  }

  .red {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Events/MeetingSignin.vue